import React from 'react';
import { SRLWrapper } from 'simple-react-lightbox';

import CustomCursor from '~/components/CustomCursor';

function Portfolio({ items = [] }) {
  const grid = ['col-span-3', 'col-span-4', 'col-span-3', 'col-span-3', 'col-span-4', 'col-span-3'];

  return (
    <section className="py-24 text-black bg-beige">
      <SRLWrapper>
        <div className="container">
          {/* <h2 className="mb-24 text-secondary-h2">{ title }</h2> */}
          <div className="grid grid-cols-2 gap-12 md:gap-y-28 lg:grid-cols-10">
            {items.map((item, i) => (
              <div key={`pi${i}`} className={`flex flex-col justify-end group relative ${grid[i]}`}>
                <CustomCursor>
                  <div className="relative mb-8 ">
                    <img src={item.image.filename} alt={item.image.filename} />
                  </div>
                  <h3 className="transition-colors duration-300 ease-in-out text-secondary-h3 group-hover:text-blue">
                    {item.heading}
                  </h3>
                </CustomCursor>
              </div>
            ))}
          </div>
        </div>
      </SRLWrapper>
    </section>
  );
}

export default Portfolio;
